import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Logo from '@src/pages/layout/Logo'

export const AccountSelectionDialog = ({ selectAccountDialogOpen, userAccounts, handleAccountSelection }) => {
  const sortedAccounts = React.useMemo(() => {
    return [...userAccounts].sort((a, b) => a.account_name.localeCompare(b.account_name))
  }, [userAccounts])

  return (
    <Dialog open={selectAccountDialogOpen} fullWidth maxWidth='xs'>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 4,
        }}
      >
        {/* Logo */}
        <Logo style={{ maxWidth: '100%' }} height='60' alt='LuxAI Logo' />

        {/* Title */}
        <Typography variant='h6' sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
          Please Select Account to Continue
        </Typography>

        {/* Account Dropdown */}
        <Autocomplete
          fullWidth
          options={sortedAccounts}
          getOptionLabel={(account) => account.account_name}
          onChange={handleAccountSelection}
          renderInput={(params) => <TextField {...params} label='Select an Account' margin='normal' />}
        />
      </DialogContent>
    </Dialog>
  )
}
